import { CSSProperties } from '../../../style';

export enum DimensionMode {
  Category = 'Category',
  CategoryGroup = 'CategoryGroup'
}

export enum AggregateMode {
  MonthlyAverage = 'MonthlyAverage',
  YearlyTotal = 'YearlyTotal'
}

export enum Datasource {
  BudgetTemplate = 'BudgetTemplate',
  AnnualGrid = 'AnnualGrid'
}

export const toggleStyle: CSSProperties = { flexDirection: 'row', alignItems: 'center', gap: 5, fontSize: 13 };
export const chartTooltipStyle: CSSProperties = {
  borderRadius: 4,
  padding: 15,
  color: 'var(--color-pageText)',
  backgroundColor: 'var(--color-modalBackground)',
  boxShadow: '0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08)',
};
